import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type PersonCardIconProps = Partial<SVGIconProps>;

const PersonCardIcon: FC<PersonCardIconProps> = (props) => (
  <SVGIcon stroke="currentColor" viewBox="0 0 21 20" {...props}>
    <path d="M14.833 17.5H6.5c-3.333 0-4.167-.833-4.167-4.167V6.667c0-3.333.833-4.167 4.167-4.167h8.333C18.166 2.5 19 3.333 19 6.667v6.667c0 3.333-.833 4.167-4.167 4.167z" />
    <path
      d="M12.333 6.667H16.5M13.166 10h3.333m-1.666 3.333H16.5"
      strokeLinecap="round"
    />
    <path d="M7.75 9.408A1.51 1.51 0 0 0 9.258 7.9 1.51 1.51 0 0 0 7.75 6.392 1.51 1.51 0 0 0 6.241 7.9 1.51 1.51 0 0 0 7.75 9.408z" />
    <path
      d="M10.666 13.608c-.117-1.208-1.075-2.158-2.283-2.267a6.43 6.43 0 0 0-1.267 0c-1.208.117-2.167 1.058-2.283 2.267"
      strokeLinecap="round"
    />
  </SVGIcon>
);

export default PersonCardIcon;
